import { useCallback } from 'react';
import { usePage } from '@inertiajs/react';

/**
 * Returns a stable __ function. Call once at the top of each component.
 * Do not call the global __() inside conditionals or loops – it uses usePage() (a hook).
 */
export function useTranslations() {
    const { props } = usePage();
    return useCallback((key, replacements = {}) => {
        let translation = props.translations?.[key] ?? key;
        Object.keys(replacements).forEach((r) => {
            translation = translation.replace(`:${r}`, replacements[r]);
        });
        return translation;
    }, [props.translations]);
}

/**
 * @deprecated Uses usePage() (a hook) – do not call inside conditionals or loops.
 * Use useTranslations() at the top of your component instead.
 */
export default function __(key, replacements = {}) {
    const { props } = usePage();
    let translation = props.translations?.[key] ?? key;
    Object.keys(replacements).forEach((r) => {
        translation = translation.replace(`:${r}`, replacements[r]);
    });
    return translation;
}

import { format, formatDuration, intervalToDuration, parse } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';

const locales = { en: enUS, fr };

export const dateFormat =  function (date, formatStr = "PP") {
    return format(date, formatStr, {
        locale: locales[window.__localeId__],
        timeZone: 'UTC',
    });
}

export const formatMinutesToHumanReadable =  function (minutes) {
    const duration = intervalToDuration({
        start: 0,
        end: minutes * 60 * 1000, // Convert minutes to milliseconds
    });

    // Extract only the relevant units for formatting
    const formatted = formatDuration(duration, {
        locale: locales[window.__localeId__],
        format: ['hours', 'minutes'],
    });

    return formatted || `${minutes} minutes`;
}

export const parseDate =  function (date, formatStr, referenceDate) {
    return parse(date, formatStr, referenceDate, {
        locale: locales[window.__localeId__],
    });
}

import numbro from 'numbro';
numbro.registerLanguage({
    languageTag: "fr",
    delimiters: {
        thousands: " ",
        decimal: ","
    },
    abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
    },
    ordinal: (number) => {
        return number === 1 ? "er" : "ème";
    },
    currency: {
        symbol: " €",
        position: "postfix",
        code: "EUR"
    },
    currencyFormat: {
        thousandSeparated: true,
        totalLength: 4,
        spaceSeparated: true,
        average: true
    },
    formats: {
        fourDigits: {
            totalLength: 4,
            spaceSeparated: true,
            average: true
        },
        fullWithTwoDecimals: {
            output: "currency",
            mantissa: 2,
            spaceSeparated: true,
            thousandSeparated: true
        },
        fullWithTwoDecimalsNoCurrency: {
            mantissa: 2,
            thousandSeparated: true
        },
        fullWithNoDecimals: {
            output: "currency",
            spaceSeparated: true,
            thousandSeparated: true,
            mantissa: 0
        }
    }
});
